import {Component} from '@angular/core';
import {Bonus} from '../../model/bonus.model';
import {ActivatedRoute, Router} from '@angular/router';
import {StateService} from '../../state.service';
import {Field} from '../../model/field.model';

@Component({
    selector: 'app-add-bonus',
    templateUrl: './add-bonus.component.html',
    styleUrls: ['./add-bonus.component.css'],
    standalone: false
})
export class AddBonusComponent {

  truffleTypes = ['Burgunder', 'Perigordtrüffel', 'Wintertrüffel', 'Frühlingstrüffel', 'Teertrüffel', 'Grosssporigetrüffel'];
  bonus = new Bonus();
  submitted = false;
  fields: Field[] = [];

  constructor(private route: ActivatedRoute, private router: Router, private stateService: StateService) {
    this.fields = this.stateService.fields;
  }

  onSubmit() {
    this.stateService.addBonus(this.bonus);
    this.submitted = true;
    this.router.navigate( ['bonus']);
  }

}
